import PortalIdParser from 'PortalIdParser';
import { createSlice } from '@reduxjs/toolkit';
import { GET_WIDGET_DATA_SUCCEEDED } from '../constants/VisitorActionTypes';
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';

/**
 * @temporary Once the in-app help gate is deleted, a lot of this code can be removed
 * @expiration 2026-08-01
 * @deprecated
 */

const DEFAULT_WIDGET_SIZE = {
  width: 376,
  height: 530
};
const UPDATED_WIDGET_SIZE = {
  width: 416,
  height: 700
};
const initialState = {
  size: DEFAULT_WIDGET_SIZE,
  /**
   * @deprecated
   * Temporarily override the widget size for portal 44300118
   * until we implement the widget size setting.
   */
  shouldBeOverriden: getIsPortal53() || PortalIdParser.get() === 44300118,
  preferredSize: null
};
const widgetSizeSlice = createSlice({
  name: 'widgetSize',
  initialState,
  reducers: {
    setWidgetSize(state, action) {
      state.size = action.payload;
    },
    setPreferredWidgetSize(state, action) {
      state.preferredSize = action.payload;
    },
    /**
     * Set the widget size to the standard size (non-expanded) based on the user's gating.
     */

    setStandardWidgetSize(state) {
      const width = UPDATED_WIDGET_SIZE.width;
      const height = !state.shouldBeOverriden ? UPDATED_WIDGET_SIZE.height : DEFAULT_WIDGET_SIZE.height;
      state.size = {
        width,
        height
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(GET_WIDGET_DATA_SUCCEEDED, state => {
      const width = UPDATED_WIDGET_SIZE.width;
      const height = !state.shouldBeOverriden ? UPDATED_WIDGET_SIZE.height : DEFAULT_WIDGET_SIZE.height;
      state.size = {
        width,
        height
      };
    });
  }
});
export const {
  setWidgetSize,
  setStandardWidgetSize,
  setPreferredWidgetSize
} = widgetSizeSlice.actions;
export default widgetSizeSlice.reducer;